"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = exports.MediaPlayer = exports.LayerSourceList = exports.LayerSource = exports.Layer = exports.AudioPlayer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var Source = exports.Source = _propTypes["default"].shape({
  type: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object])
});
var Layer = exports.Layer = _propTypes["default"].shape({
  style: _propTypes["default"].object
});
var LayerSource = exports.LayerSource = {
  _id: _propTypes["default"].string,
  source: Source,
  layer: Layer
};
var LayerSourceList = exports.LayerSourceList = _propTypes["default"].arrayOf(_propTypes["default"].shape(LayerSource));
var MediaPlayer = exports.MediaPlayer = _propTypes["default"].shape({
  isPlaying: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  seek: _propTypes["default"].number,
  muted: _propTypes["default"].bool,
  loop: _propTypes["default"].bool
});
var AudioPlayer = exports.AudioPlayer = _propTypes["default"].shape({
  isPlaying: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  loop: _propTypes["default"].bool
});